<script lang="ts">
  import { page } from '$app/stores';
  import type { InstitutionsReadStoreConfigurationsResponse } from '@do/shop-api';
  import { cn } from '@shared/lib';
  import { Icon } from '@shared/ui/icon';
  import { SocialProfiles } from '@shared/ui/social-profiles';

  $: configurations = $page.data.configurations as InstitutionsReadStoreConfigurationsResponse;
</script>

<h1 class="mb-8 text-center text-4xl font-medium md:text-start md:text-6xl xl:mb-12">Get in Touch with Us</h1>

<p class="mx-auto mb-8 text-center text-base md:mb-12 md:text-start">
  If you have any inquiries about the digital collection or need assistance with technical matters, please feel free to
  reach out to us through your preferred contact method.
</p>

<div class="gap mb-8 flex flex-col gap-8 md:grid md:grid-cols-2">
  {#if configurations.locations && configurations.contacts}
    <ul class="flex flex-col gap-8">
      {#each configurations.contacts as contact}
        {@const href = contact.type === 'email' ? `mailto:${contact.value}` : `tel:${contact.value}`}

        <li>
          <p class="text-default-500 mb-3 flex items-center gap-2 text-sm font-medium uppercase md:mb-4">
            <Icon name="{contact.type}" width="{20}" height="{20}" classes="shrink-0" />

            {contact.type}
          </p>

          <a
            {href}
            class="{cn('text-base', {
              'underline-hover after:bg-default-400 dark:after:bg-default-500 border-b after:absolute after:-bottom-[1px] after:left-0 after:right-0 after:h-[1px]':
                contact.type === 'email',
            })}"
          >
            {contact.value}
          </a>
        </li>
      {/each}
    </ul>

    <div>
      <p class="text-default-500 mb-3 flex items-center gap-2 text-sm font-medium uppercase md:mb-4">
        <Icon name="location" width="{20}" height="{20}" classes="shrink-0" />
        Location
      </p>

      <p class="text-base">
        {configurations.locations[0].address}
      </p>
    </div>
  {/if}
</div>

<SocialProfiles socials="{configurations.social_profiles}" />
